import { type GetHookResponse } from '../hooks'
import { eventKey } from '../keys'
import { useTantalimQuery } from '../query'
import { useUserCache } from '../user'
import {
  type CalendarEventDataWithDetails,
  type CalendarEventGetInput,
  type CalendarEventGetSuccess,
  type CalendarEventId,
  CURRENT_VERSION,
  HOUR,
} from '@terros/common'
import { type UseQueryOptions } from '@tanstack/react-query'

type EventGetQueryOptions = {
  enabled?: boolean
} & Pick<UseQueryOptions<CalendarEventDataWithDetails>, 'retry'>

export function useCalendarEvent(
  eventId: CalendarEventId,
  options?: EventGetQueryOptions
): GetHookResponse<CalendarEventDataWithDetails> {
  const cache = useUserCache()
  return useTantalimQuery<CalendarEventGetInput, CalendarEventGetSuccess, CalendarEventDataWithDetails>({
    url: '/calendar/event/get',
    queryKey: eventKey(eventId),
    input: { eventId, version: CURRENT_VERSION },
    convertResponse: ({ event }) => {
      if (event.owner) cache.setTinyUser(event.owner)
      if (event.attendee) cache.setTinyUser(event.attendee)
      return event
    },
    options: {
      ...options,
      gcTime: HOUR,
    },
  })
}
